// Calendar dates belong to the community timezone, never the browser's UTC offset.
export function seasonState(season, now = new Date()) {
  if (!season?.startDate || !season?.endDate) return null;
  const today = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit'
  }).format(now);
  const start = season.startDate.slice(0, 10);
  const end = season.endDate.slice(0, 10);
  const days = Math.round((Date.parse(`${start}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) / 86400000);
  return { phase: today < start ? 'upcoming' : today > end ? 'ended' : 'live', days };
}

export function seasonDates(season) {
  if (!season?.startDate || !season?.endDate) return '2026 reading challenge';
  const format = (date) => new Intl.DateTimeFormat('en-US', {
    month: 'short', day: 'numeric', timeZone: 'UTC'
  }).format(new Date(`${date.slice(0, 10)}T12:00:00Z`));
  return `${format(season.startDate)} – ${format(season.endDate)}, ${season.endDate.slice(0, 4)}`;
}
